// Canvas sizing: DPR-aware backing store, capped at 2× so huge retina displays don't
// tank fill-rate. Regenerates the paper background on every resize.
import { G } from '../game/state';
import { makeBg } from './background';

export function resize(): void {
  G.DPR = Math.min(window.devicePixelRatio || 1, 2);
  G.W = window.innerWidth;
  G.H = window.innerHeight;
  G.canvas.width = G.W * G.DPR;
  G.canvas.height = G.H * G.DPR;
  G.canvas.style.width = G.W + 'px';
  G.canvas.style.height = G.H + 'px';
  G.ctx.setTransform(G.DPR, 0, 0, G.DPR, 0, 0);
  makeBg();
}
